import axios from "axios";
import { SUPPORT_STAFF_LIST, SUPPORT_STAFF_DETAIL } from "../actions";

const PROXY = process.env.REACT_APP_URL + "api/";

export const getSupportStaffList =
  (page, limit, search) => async (dispatch) => {
    try {
      const res = await axios.get(
        `${PROXY}staff-support/get?page=${page}&limit=${limit}&search=${search}`
      );
      dispatch({
        type: SUPPORT_STAFF_LIST,
        payload: res.data.result,
      });
      return res
    } catch (err) {
      console.error(err);
    }
  };

export const addSupportStaff = (data) => async () => {
  const res = await axios.post(`${PROXY}staff-support/add`, data);
  return res;
};

export const getSupportStaffDetail = (id) => async (dispatch) => {
  const res = await axios.get(`${PROXY}staff-support/details/${id}`);
  dispatch({
    type: SUPPORT_STAFF_DETAIL,
    payload: res.data.result[0],
  });
  return res.data.result;
};

export const changeStatusSupportStaff = (id, status) => async () => {
  const res = await axios.put(
    `${PROXY}staff-support/change-status/${status}/${id}`
  );
  return res;
};

export const getStaffSupportNotification = () => async (dispatch) => {
  const res = await axios.get(`${PROXY}notification/owner/staff-support`);

  return res.data.result;
};
